import { Fragment, useEffect, useState } from 'react'

import classNames from 'classnames'

import Loading from 'Root/Loader'
import { Router } from 'next/router'

import styles from './index.module.css'

interface Props {
  children?: React.ReactNode
  className?: string
  forceLoading?: boolean
}

const Body = ({ children, className, forceLoading = false }: Props) => {
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    const start = () => {
      setLoading(true)
      window.scrollTo(0, 0)
    }

    const end = () => setLoading(false)

    Router.events.on('routeChangeStart', start)
    Router.events.on('routeChangeComplete', end)
    Router.events.on('routeChangeError', end)

    return () => {
      Router.events.off('routeChangeStart', start)
      Router.events.off('routeChangeComplete', end)
      Router.events.off('routeChangeError', end)
    }
  }, [])

  return (
    <div className={classNames(styles.bodyWrapper, className)}>
      {(loading || forceLoading) && (
        <div className={styles.loadingContainer}>
          <Loading className={styles.loadingIcon} />
        </div>
      )}
      {!loading && !forceLoading && <Fragment>{children}</Fragment>}
    </div>
  )
}

export default Body
